export const truncatedDeclaration = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
};

export const truncatedStyle = {
  '& .truncated': truncatedDeclaration,
};
